import { Chip } from "@heroui/react";

type Named = { id: string; name: string };

/** A main name with a quiet second line, such as a category over its sub category. The "+N" counts the rest. */
export function NamesCell({
  primary,
  secondary,
}: {
  primary: Named[];
  secondary?: Named[];
}) {
  if (primary.length === 0 && !secondary?.length) {
    return <span className="text-muted text-sm">-</span>;
  }

  return (
    <div className="flex max-w-[115px] min-w-0 flex-col gap-0.5 leading-tight">
      <div className="flex items-center gap-1.5">
        <span className="truncate text-sm whitespace-nowrap">{primary[0]?.name ?? "-"}</span>
        {primary.length > 1 ? (
          <Chip size="sm" variant="soft">
            +{primary.length - 1}
          </Chip>
        ) : null}
      </div>
      {secondary && secondary.length > 0 ? (
        <div className="flex items-center gap-1.5">
          <span className="text-muted truncate text-xs whitespace-nowrap">
            {secondary[0].name}
          </span>
          {secondary.length > 1 ? (
            <Chip size="sm" variant="soft">
              +{secondary.length - 1}
            </Chip>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
